import { parsePhoneNumber } from "awesome-phonenumber";

export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';

    try {
        const parsed = parsePhoneNumber(phoneNumber, { regionCode: "IL" });
        return parsed.number.national || phoneNumber;
    } catch (error) {
        console.warn('Error formatting phone number:', error);
        return phoneNumber;
    }
}; 